import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, InputAdornment, MenuItem, TextField, Typography } from "@mui/material";
import LabeledSelect from "apps/web/src/components/universal/LabeledSelect";
import { useGoalConfigurationTemplatePageContext } from "../GoalConfigurationTemplateProvider";

interface TablePageDefaultHeaderProps {
    onCreate?: () => void;
}

export const TablePageHeader = ({
    onCreate,
}: TablePageDefaultHeaderProps) => {
    const { category, setCategory, target, setTarget, createdByMe, setCreatedByMe, categoryOptions, targetOptions, paginationHooks } = useGoalConfigurationTemplatePageContext();
    const { queryText, onChangeQueryText, resetOffset } = paginationHooks;

    return (
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignItems: "flex-end", flex: 1 }}>
            <LabeledSelect
                optionToName={option => `${option.defaultEmoji} ${option.name}`}
                sx={{ maxWidth: 180 }}
                placeholder="Type"
                onChange={value => {
                    setCategory(value);
                    resetOffset();
                }}
                selectedOption={category}
                options={categoryOptions}
                renderOption={option => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.id === "none" ? (
                            <Typography variant="body2" sx={{ lineHeight: "24px" }} color="mediumEmphasisTextLight">
                                {option.name}
                            </Typography>
                        ) : (
                            `${option.defaultEmoji} ${option.name}`
                        )}
                    </MenuItem>
                )}
            />
            <LabeledSelect
                optionToName={option => option.unit}
                sx={{ maxWidth: 190 }}
                placeholder="Completion Criteria"
                onChange={value => {
                    setTarget(value);
                    resetOffset();
                }}
                selectedOption={target}
                options={targetOptions}
                renderOption={option => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.id === "none" ? (
                            <Typography variant="body2" sx={{ lineHeight: "24px" }} color="mediumEmphasisTextLight">
                                {option.unit}
                            </Typography>
                        ) : (
                            option.unit
                        )}
                    </MenuItem>
                )}
            />
            <TextField
                sx={{ width: 180 }}
                select
                inputProps={{ "aria-label": "Created By" }}
                value={createdByMe ? "me" : "anyone"}
                onChange={e => {
                    setCreatedByMe(e.target.value === "me" ? true : false);
                    resetOffset();
                }}
                label="Created By"
            >
                <MenuItem value="anyone">Anyone</MenuItem>
                <MenuItem value="me">Me</MenuItem>
            </TextField>
            {queryText !== undefined && onChangeQueryText && (
                <TextField
                    sx={{ mt: 0, width: 260 }}
                    placeholder="Search"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    onChange={e => onChangeQueryText(e.target.value)}
                    value={queryText}
                />
            )}
            {onCreate && <Button onClick={onCreate}>Create Goal</Button>}
        </Box>
    );
};
